import React, { useEffect, useMemo, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import {
  getResolvedTheme,
  getThemeSettings,
  saveThemeSettings,
  themeChangeEventName,
} from './lib/themePreferences';
import './styles/account.css';

const SettingsPage = () => {
  const { isLoading, isAuthenticated } = useAuth();
  const [settings, setSettings] = useState(() => getThemeSettings());

  const resolvedTheme = useMemo(() => getResolvedTheme(settings), [settings]);

  useEffect(() => {
    const handleThemeChange = (event) => {
      setSettings({
        mode: event.detail?.mode === 'dark' ? 'dark' : 'light',
        syncWithDevice: Boolean(event.detail?.syncWithDevice),
      });
    };

    window.addEventListener(themeChangeEventName, handleThemeChange);

    return () => {
      window.removeEventListener(themeChangeEventName, handleThemeChange);
    };
  }, []);

  const handleModeChange = (mode) => {
    const nextSettings = {
      mode,
      syncWithDevice: settings.syncWithDevice,
    };

    saveThemeSettings(nextSettings);
    setSettings(nextSettings);
  };

  const handleSyncChange = (event) => {
    const nextSettings = {
      mode: settings.mode,
      syncWithDevice: event.target.checked,
    };

    saveThemeSettings(nextSettings);
    setSettings(nextSettings);
  };

  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/main" replace />;
  }

  return (
    <main className="content">
      <section className="account-page">
        <div className="account-hero">
          <div>
            {/* <span className="account-kicker">Настройки</span> */}
            <h1>Настройки аккаунта</h1>
            <p>
              
            </p>
          </div>
          <div className="account-hero-actions">
            <Link className="account-primary-btn settings-link-btn" to="/account">Перейти в аккаунт</Link>
            <Link className="account-secondary-link" to="/main">Вернуться к ленте</Link>
          </div>
        </div>

        <section className="account-card">
          <div className="settings-block-head">
            <div>
              <h2>Тема сайта</h2>
              <p className="account-empty">
                  Выберите, как будет выглядеть сайт: в светлом или тёмном режиме. Если включить синхронизацию с устройством, сайт будет автоматически подстраиваться под системные настройки вашего телефона или компьютера.
              </p>
            </div>
            <span className="settings-theme-badge">
              Сейчас: {resolvedTheme === 'dark' ? 'Тёмная' : 'Светлая'}
            </span>
          </div>

          <div className="settings-theme-grid">
            <button
              type="button"
              className={`settings-theme-card ${!settings.syncWithDevice && settings.mode === 'light' ? 'active' : ''}`}
              onClick={() => handleModeChange('light')}
            >
              <span className="settings-theme-card-kicker">Ручной режим</span>
              <strong>Светлая тема</strong>
              <span>Светлый фон, обычный контраст.</span>
            </button>

            <button
              type="button"
              className={`settings-theme-card ${!settings.syncWithDevice && settings.mode === 'dark' ? 'active' : ''}`}
              onClick={() => handleModeChange('dark')}
            >
              <span className="settings-theme-card-kicker">Ручной режим</span>
              <strong>Тёмная тема</strong>
              <span>Тёмный фон, высокий контраст.</span>
            </button>
          </div>

          <label className="settings-sync-toggle">
            <input
              type="checkbox"
              checked={settings.syncWithDevice}
              onChange={handleSyncChange}
            />
            <span>
              <strong>Синхронизировать с темой устройства</strong>
              <small>
                Если галочка включена, сайт сам переключится между светлой и тёмной темой
                по системным настройкам телефона или компьютера.
              </small>
            </span>
          </label>
          {settings.syncWithDevice && (
            <p className="account-empty settings-sync-note">
              Синхронизация с устройством включена. Сайт будет автоматически менять тему в зависимости от системных настроек вашего телефона или компьютера. Чтобы выбрать конкретную тему, отключите синхронизацию.
            </p>
          )}
        </section>
      </section>
    </main>
  );
};

export default SettingsPage;
